import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  settings;
  settingsDoc;
  playerName = '';
  playerPictureUrl = '';
  playerOrder = '';
  constructor(private afs: AngularFirestore, public afAuth: AngularFireAuth, public sharedService: SharedService) { }

  ngOnInit() {
    const that = this;
    this.settingsDoc = this.afs.doc('settings/' + 'c3AIhlbEFfjGjzJU6WY3');
    this.settingsDoc.valueChanges().subscribe(settings => {
      that.settings = settings;
    });
    }

    saveSettings() {
      this.settingsDoc.update(this.settings);
    }

    addPlayer() {
      if (this.playerPictureUrl && this.playerName) {
        this.sharedService.addPlayer(this.playerName, this.playerPictureUrl, this.playerOrder);
        this.playerName = '';
        this.playerPictureUrl = '';
        this.playerOrder = '';
      }
    }
  }



// WEBPACK FOOTER //
// ./src/app/components/settings/settings.component.ts